/** @jsx jsx */
import { useState } from 'react';
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import Grid from '@material-ui/core/Grid';
import { Button, ButtonStyle } from "../button/Button";
import { Magnetic } from "../../styles";
import { StyledSearchBoxInput, SearchInputError, StyledSearchBoxIcon, StyledSearchBoxInputCss, StyledCrossIcon, StyledSearchBoxContainer, StyledSearchButton } from './SearchBox.style';
import { ENTER, SEARCH, CANCEL } from './constants';
const StyledButton = styled(Button)(`
	margin-left: ${Magnetic.annotationBaseMargin}
`);
/**
 * @param onSearch callback method for Search
 * @param cancelButtonProps control the UI and behavior of cancel button control
 * @param searchInputProps control the UI and behavior of search input control
 * @param searchButtonProps [Optional] control the UI and behavior of search button control
 * @param translateFn [Optional] used for translations
 * @param isLiveSearch [Optional] used to enable live search icon
 * @param shouldShowCrossIcon [Optional] used to enable cross icon
 * @param onCancelIconClick [Optional] callback method for cross icon click
 */
export const SearchBox = (props) => {
    const [searchValue, setSearchValue] = useState(props.searchInputProps.value || '');
    const [isHideCancelIcon, setIsHideCancelIcon] = useState(true);
    const [prevSearchInputValue, setPrevSearchInputValue] = useState(props.searchInputProps.value);
    if (props.searchInputProps.value !== prevSearchInputValue) {
        setPrevSearchInputValue(props.searchInputProps.value);
        setSearchValue(props.searchInputProps.value || '');
    }
    const onSearch = () => {
        props.onSearch(searchValue);
    };
    const onChange = (event) => {
        setSearchValue(event.target.value);
        setIsHideCancelIcon(false);
        props.searchInputProps.onChange(event);
    };
    const onSearchKeyPress = (event) => {
        if (event.key === ENTER) {
            onSearch();
        }
    };
    const onCancelClick = (event) => {
        setSearchValue('');
        props.cancelButtonProps.onClick(event);
    };
    const onCancelIconClick = () => {
        setSearchValue('');
        setIsHideCancelIcon(true);
        props.onCancelIconClick && props.onCancelIconClick();
    };
    const onMouseLeaveSearchBox = () => {
        setIsHideCancelIcon(true);
    };
    const onMouseEnterSearchBox = () => {
        searchValue && setIsHideCancelIcon(false);
    };
    return (jsx(Grid, { container: true },
        jsx(StyledSearchBoxContainer, { item: true, xs: true, onMouseLeave: onMouseLeaveSearchBox, id: "searchbox_container", shouldShowCrossIcon: props.shouldShowCrossIcon },
            props.isLiveSearch && (jsx(StyledSearchBoxIcon, { className: "mi-icon-search" })),
            jsx(StyledSearchBoxInput, Object.assign({}, props.searchInputProps, { value: searchValue, autoFocus: props.searchInputProps.shouldAutoFocus, disabled: props.searchInputProps.isDisabled, onKeyPress: onSearchKeyPress, onChange: onChange, onMouseEnter: onMouseEnterSearchBox, id: props.searchInputProps.id || 'miSearchBoxTextBox', placeholder: props.searchInputProps.placeholder || props.translateFn(SEARCH), css: props.searchInputProps.hasError
                    ? SearchInputError
                    : props.isLiveSearch
                        ? StyledSearchBoxInputCss
                        : '', isLiveSearch: props.isLiveSearch })),
            props.shouldShowCrossIcon && (jsx(StyledCrossIcon, { icon: "mi-icon-close", iconSize: 14, style: ButtonStyle.Flat, id: "miSearchBoxCrossIcon", onClick: onCancelIconClick, isHideCancelIcon: isHideCancelIcon }))),
        !props.isLiveSearch && (jsx(Grid, { item: true },
            jsx(StyledSearchButton, { type: props.searchButtonProps && props.searchButtonProps.type, style: ButtonStyle.Search, id: (props.searchButtonProps && props.searchButtonProps.id) || 'miSearchBoxSearchBtn', onClick: (event) => {
                    event.preventDefault();
                    onSearch();
                }, disabled: (props.searchButtonProps && props.searchButtonProps.disabled) || false }))),
        !props.cancelButtonProps.shouldHide && (jsx(Grid, { item: true },
            jsx(StyledButton, Object.assign({}, props.cancelButtonProps, { onClick: onCancelClick, id: props.cancelButtonProps.id || 'miSearchBoxCancelBtn', label: props.cancelButtonProps.label || props.translateFn(CANCEL) }))))));
};
SearchBox.defaultProps = {
    translateFn: (key) => key,
    isLiveSearch: false
};
//# sourceMappingURL=SearchBox.js.map